var _defs, _polygon, _path, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.52 50.77 56.24 56.05 56.24 14 51.24 14 51.24 56.28 45.74 50.77 42.2 54.31 53.63 65.73 65.06 54.31 61.52 50.77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,14l-7.26,21.16v2.84h5v-1.91l.72-2.09h7.04l.72,2.09v1.91h5v-2.84l-7.26-21.16h-3.96ZM22.37,29.03l1.81-5.29,1.81,5.29h-3.63Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.49 48 27.13 48 15.24 60.21 15.24 66 33 66 33 61 21.36 61 33.24 48.79 33.24 43 15.49 43 15.49 48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/Name.41d3859c96958d0683feb2961617aadf.svg";
export { ForwardRef as ReactComponent };